import { render, staticRenderFns } from "./booklet.vue?vue&type=template&id=17e8b6b4&"
import script from "./booklet.vue?vue&type=script&lang=js&"
export * from "./booklet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports